export default "__VITE_ASSET__f4b511a7__"